if (!customElements.get('quickbuy-variant-radios')) {
  class QuickbuyVariantRadios extends VariantSelects {
    constructor() {
      super();
      this.dataset.updateUrl = false;
      this.dataset.updateSwatch = false;
      this.dataset.updateVariantTitle = true;

      this.querySelector('.quickbuy-form__show-more-variants').addEventListener('click', this.toggleMoreVariants)
    }

    toggleMoreVariants(e) {
      e.preventDefault();
      let cardInfo = this.closest('.card-information')
      let variantContainer = cardInfo.querySelector('quickbuy-variant-radios fieldset')
      variantContainer.classList.toggle('active')
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const newMedia = document.querySelectorAll(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `QuickBuy-MediaGallery-${this.dataset.section}`
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;
        });

      if (!newMedia) return;
      newMedia.forEach((media) => {
        const parent = media.parentElement;

        // move variant featured image to top
        parent.prepend(media);

        // make new featured variant image the active image
        media.classList.add('active')
      })
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        // Update product link with selected variant
        const productLink = productForm.closest(".card-wrapper")?.querySelector(".card__link");
        if (productLink) {
          const href = productLink.getAttribute("href");
          href.includes("?variant")
            ? productLink.setAttribute("href", `${href.split("?")[0]}?variant=${this.currentVariant.id}`)
            : productLink.setAttribute("href", `${href}?variant=${this.currentVariant.id}`);
        }
      });
    }
  }

  customElements.define('quickbuy-variant-radios', QuickbuyVariantRadios);
}
